<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1"> </p>
<p class="PN" id="pt1"><a id="pg_15">PART ONE</a></p><a id="pg_15">
<p class="PT"><span class="ePub-B">1945–1949</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?a5a2ce36